<template>
    <ion-buttons>
      <router-link class="btn-icon btn-vertical" v-for="menu in menus" :key="menu.text" :to="menu.link">
              <span>
                <font-awesome-icon :icon="[menu.iconType, menu.iconName]" />
              </span>
              <p>{{menu.text}}</p>
        </router-link>
    </ion-buttons>
</template>


<script>
import { mapGetters } from 'vuex'
import {ApplicationsAccessEnum} from "@/services/Enum/ApplicationsAccessEnum";
import ApiAuthenticationService from "@/services/ApiAuthenticationService";

const menuResume = {
  link:'/resume/',
  text:'Résumé',
  iconType:'fas',
  iconName:'file'
};
const menuParcourir = {
  link:'/parcourir/',
  text:'Parcourir',
  iconType:'far',
  iconName:'telescope'
};
const menuPro = {
  link:'/pro/',
  text:'PRO',
  iconType:'far',
  iconName:'bullseye-arrow'
};
const menuCommerciaux = {
  link:'/commerciaux/',
  text:'Commerciaux',
  iconType:'far',
  iconName:'users'
};
const menuConcours = {
  link:'/challenges/',
  text:'Challenges',
  iconType:'far',
  iconName:'trophy-alt'
};
const menuExport = {
  link: '/exports/',
  text: 'Export',
  iconType: 'far',
  iconName: 'file-export'
};

export default {
  name: "MenuMain",
  data(){
    return {
      menus:[]
    }
  },
  computed: {
    ...mapGetters
  },
  created (){
    let currentUserApplicationsAccess = ApiAuthenticationService.getCurrentUser().applicationsAccess;
    if (typeof currentUserApplicationsAccess === 'object') {
      currentUserApplicationsAccess = Object.values(currentUserApplicationsAccess);
    }
    if (currentUserApplicationsAccess.includes(ApplicationsAccessEnum.APP_RESUME)) {
      this.menus.push(menuResume)
    }
    if (currentUserApplicationsAccess.includes(ApplicationsAccessEnum.APP_CONCOURS)) {
      this.menus.push(menuConcours)
    }
    if (currentUserApplicationsAccess.includes(ApplicationsAccessEnum.APP_PARCOURIR_NATIONAL) || currentUserApplicationsAccess.includes(ApplicationsAccessEnum.APP_PARCOURIR)) {
      this.menus.push(menuParcourir)
    }
    if (currentUserApplicationsAccess.includes(ApplicationsAccessEnum.APP_EXPORT) || currentUserApplicationsAccess.includes(ApplicationsAccessEnum.APP_ADMIN_EXPORT)) {
      this.menus.push(menuExport)
    }
    if (currentUserApplicationsAccess.includes(ApplicationsAccessEnum.APP_COMMERCIALS)) {
      this.menus.push(menuCommerciaux)
    }
    if (currentUserApplicationsAccess.includes(ApplicationsAccessEnum.APP_PRO_PERSONAL)) {
      this.menus.push(menuPro)
    }
  }
}
</script>
